import React from 'react';
import Nav from '../components/Nav';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Ready from '../components/Ready';
import Testimonials from '../components/Testimonials';
import Benefits from '../components/Benefits';
import RecentBlogs from '../components/RecentBlogs';
import Pricing from '../components/pricing/Pricing';
import EarlyAccessPopup from '../components/dialogbox/EarlyAccessPopup';
import DashboardShowcase from '../components/DashboardShowcase/DashboardShowcase';
import CalculatorsSection from '../components/CalculatorsSection';
import FeaturesSection from '../components/FeaturesSection';
import BenefitsSection from '../components/BenefitsSection';
import HowItWorksSection from '../components/HowItWorksSection';

const LandingPage = () => {
  return (
    <div className="LandingPage">
      <Nav />
      <Header />
      
      {/* Core Features Section */}
      <FeaturesSection />

      {/* Dashboard Showcase */}
      <DashboardShowcase />

      {/* Key Benefits */}
      <BenefitsSection />

      {/* How It Works */}
      <HowItWorksSection />

      {/* Pricing */}
      <Pricing />
      
      {/* Testimonials */}
      <Testimonials />
      
      {/* Calculators Quick Access */}
      <CalculatorsSection />
      
      {/* Recent Blogs */}
      {/* <RecentBlogs /> */}
      
      {/* Footer */}
      <Footer />

      {/* Early Access Popup */}
      <EarlyAccessPopup />
    </div>
  );
};

export default LandingPage;